import { combineReducers } from 'redux';

import { i18nReducer } from 'react-redux-i18n';
import { reducer as formReducer } from 'redux-form';
import auth from './auth';
import question from './question';
import menu from './menu';
import classroom from './classroom';
import quiz from './quiz';
import flashcard from './flashcard';
import question_learning from './question_learning';
import presentation from './presentation';
import slider from './slider';

export default combineReducers({
  form: formReducer,

  i18n: i18nReducer,
  auth,
  question,
  menu,
  classroom,
  quiz,
  flashcard,
  question_learning,
  presentation,
  slider,
});
